/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree } from '../helpers/savedSearches';

const customId = 'getSavedSearchesFailed';

export const getSavedSearches = createAsyncThunk(
  'savedSearches/getSavedSearches',
  async (_, { getState, extra: { sdk, Logger, Toast } }) => {
    const userId = getState().user._id;

    try {
      const { data: savedSearches } = await sdk.savedSearches.getAll();
      return { savedSearches, userId };
    } catch (error) {
      Logger.log('UI', 'ToastSavedSearchesNotLoaded');
      Toast(
        'Saved searches has not loaded. Try refreshing the page to see them.',
        {
          toastId: customId,
          autoClose: false,
          type: 'error',
        },
      );
      Logger.error(new Error('Can not get saved searches'), { error }, [
        'GetSavedSearchesFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(
      getSavedSearches.pending,
      (state) => {
        state.isLoaded = false;
        state.isLoading = true;
        state.tree = null;
        state.all = [];
        state.error = null;
      },
    )
    .addCase(
      getSavedSearches.fulfilled,
      (state, { payload: { savedSearches, userId } }) => {
        state.isLoaded = true;
        state.isLoading = false;
        state.error = null;
        state.tree = makeTree(savedSearches?.nodes, userId);
        state.all = savedSearches.nodes;
      },
    )
    .addCase(
      getSavedSearches.rejected,
      (state, { error }) => {
        state.isLoaded = false;
        state.isLoading = false;
        state.error = error;
        state.tree = null;
        state.all = [];
      },
    );
};
